module.exports = __webpack_public_path__ + "static/media/COS_BD.2c0ccee9.png";